import wretch from "wretch";

export interface Testimonial {
  text: string;
}

const TESTIMONIALS_URL = import.meta.env.VITE_FRONTPAGE_TESTIMONIALS_URL;

export const getTestimonialList = async () => {
  try {
    const res: Testimonial[] = await wretch(TESTIMONIALS_URL)
      .headers({
        "cache-control": "public, max-age=3600"
      }) // instructs CDN to cache for 1 hour
      .get()
      .json();
    return res;
  } catch (error) {
    console.log(error);
    return [];
  }
};
